<script setup>
import { ref, onMounted, computed } from 'vue'
import { post } from '@/api/Services'
import { useStore } from 'vuex'

import Skeleton from 'primevue/skeleton'

const store = useStore()
const loggeduser = computed(() => store.state.account.loggeduser)

const email = ref('')

const products = ref([
  {
    id: 0,
    heading: 'Lorem ipsum dolor sit amet',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam quos quas, quia, quae, quisquam quos quas, quia, quae, quisquam',
    image: 'https://thispersondoesnotexist.com',
    name: 'Sophia Moore',
    position: 'CEO at Webflow Agency',
  },
  {
    id: 1,
    heading: 'Lorem ipsum dolor sit amet',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam quos quas, quia, quae, quisquam quos quas, quia, quae, quisquam',
    image: 'https://thispersondoesnotexist.com',
    name: 'Sophia Moore',
    position: 'CEO at Webflow Agency',
  },
  {
    id: 2,
    heading: 'Lorem ipsum dolor sit amet',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam quos quas, quia, quae, quisquam quos quas, quia, quae, quisquam',
    image: 'https://thispersondoesnotexist.com',
    name: 'Sophia Moore',
    position: 'CEO at Webflow Agency',
  },
  {
    id: 3,
    heading: 'Lorem ipsum dolor sit amet',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam quos quas, quia, quae, quisquam quos quas, quia, quae, quisquam',
    image: 'https://thispersondoesnotexist.com',
    name: 'Sophia Moore',
    position: 'CEO at Webflow Agency',
  },
  {
    id: 4,
    heading: 'Lorem ipsum dolor sit amet',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam quos quas, quia, quae, quisquam quos quas, quia, quae, quisquam',
    image: 'https://thispersondoesnotexist.com',
    name: 'Sophia Moore',
    position: 'CEO at Webflow Agency',
  },
])
const responsiveOptions = ref([
  {
    breakpoint: '1440px',
    numVisible: 2,
    numScroll: 1,
  },
  {
    breakpoint: '867px',
    numVisible: 1,
    numScroll: 1,
  },
])
const cmsData = ref([])
const header = ref('')
const header_subtext = ref('')
const mission_header = ref('')
const mission_subheader = ref('')
const mission_paragraph = ref('')
const mission_img = ref('')
const mediaURL = ref(process.env.VUE_APP_MEDIA_URL)
const mission_stats_header = ref('')
const mission_stats_paragraph = ref('')
const mission_stats_subheader = ref('')
const mission_stats_header_2 = ref('')
const mission_stats_paragraph_2 = ref('')
const mission_stats_subheader_2 = ref('')
const about_header = ref('')
const about_subheader = ref('')
const about_paragraph = ref('')
const about_img = ref('')
const mail_header = ref('')
const mail_paragraph = ref('')
const testimonial_header = ref('')
const testimonial_subheader = ref('')
const cms = async () => {
  const parameters = [
    {
      parameter_name: 'piv_page_path',
      parameter_value: '/about-us',
    },
    {
      parameter_name: 'piv_tag_group',
      parameter_value: 'general',
    },
  ]

  await post('/Commons/Executer', {
    sqlId: 76,
    parameters: JSON.stringify(parameters),
  })
    .then((data) => {
      console.log(data)
      cmsData.value = data
      cmsData.value.map((item) => {
        switch (item.tag) {
          case 'header':
            header.value = item.html_content
            break
          case 'header_subtext':
            header_subtext.value = item.html_content
            break
          case 'mission_header':
            mission_header.value = item.html_content
            break
          case 'mission_subheader':
            mission_subheader.value = item.html_content
            break
          case 'mission_paragraph':
            mission_paragraph.value = item.html_content
            break
          case 'mission_img':
            mission_img.value = item.file_path
            break
          case 'mission_stats_header':
            mission_stats_header.value = item.html_content
            break
          case 'mission_stats_paragraph':
            mission_stats_paragraph.value = item.html_content
            break
          case 'mission_stats_subheader':
            mission_stats_subheader.value = item.html_content
            break
          case 'mission_stats_header_2':
            mission_stats_header_2.value = item.html_content
            break
          case 'mission_stats_paragraph_2':
            mission_stats_paragraph_2.value = item.html_content
            break
          case 'mission_stats_subheader_2':
            mission_stats_subheader_2.value = item.html_content
            break
          case 'about_header':
            about_header.value = item.html_content
            break
          case 'about_subheader':
            about_subheader.value = item.html_content
            break
          case 'about_paragraph':
            about_paragraph.value = item.html_content
            break
          case 'about_img':
            about_img.value = item.file_path
            break
          case 'mail_header':
            mail_header.value = item.html_content
            break
          case 'mail_paragraph':
            mail_paragraph.value = item.html_content
            break
          case 'testimonial_header':
            testimonial_header.value = item.html_content
            break
          case 'testimonial_subheader':
            testimonial_subheader.value = item.html_content
            break
        }
      })
    })
    .catch((err) => console.log(err))
}

onMounted(() => {
  cms()
})
</script>

<template>
  <div class="container p-mx-auto p-4">
    <!-- Header Section with Skeleton -->
    <div class="d-flex mx-auto flex-column gap-8 w-100 mb-5">
      <div class="d-flex flex-column text-center gap-4">
        <template v-if="cmsData.length > 0">
          <h1 class="title fs-xxlarge">{{ header }}</h1>
          <p class="subtitle">
            {{ header_subtext }}
          </p>
        </template>
        <template v-else>
          <Skeleton width="60%" height="50px" class="mx-auto mb-2" />
          <Skeleton width="80%" height="24px" class="mx-auto" />
        </template>
      </div>
    </div>

    <!-- Mission Section with Skeleton -->
    <div class="relative">
      <template v-if="cmsData.length > 0">
        <h4 class="card-subtitle mb-2">{{ mission_header }}</h4>
        <div>
          <h2 class="card-title">
            {{ mission_subheader }}
          </h2>
          <div
            id="quality"
            class="d-flex align-content-center justify-content-center gap-8"
          >
            <div class="img">
              <img
                width="560"
                height="400"
                :src="`${mediaURL}${mission_img}`"
                alt="quality"
                class="p-overflow-hidden"
                style="border-radius: 12px"
              />
            </div>
            <div class="d-flex mt-2 stat relative">
              <p class="card-paragraph">
                {{ mission_paragraph }}
              </p>
              <div class="stats-section gap-8">
                <div class="mask">
                  <svg
                    width="185"
                    height="184"
                    viewBox="0 0 185 184"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_155_2196"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="185"
                      height="184"
                    >
                      <circle
                        cx="101"
                        cy="100"
                        r="84"
                        fill="white"
                        fill-opacity="0.12"
                      />
                      <circle
                        cx="43"
                        cy="43"
                        r="43"
                        fill="#FFF9F9"
                        fill-opacity="0.13"
                      />
                    </mask>
                    <g mask="url(#mask0_155_2196)">
                      <rect y="-1" width="127" height="161" fill="#D9D9D9" />
                    </g>
                  </svg>
                </div>
                <div class="stat-item">
                  <h3>{{ mission_stats_header }}</h3>
                  <p>{{ mission_stats_subheader }}</p>
                  <span>{{ mission_stats_paragraph }}</span>
                </div>
                <div class="stat-item">
                  <h3>{{ mission_stats_header_2 }}</h3>
                  <p>{{ mission_stats_subheader_2 }}</p>
                  <span>{{ mission_stats_paragraph_2 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <Skeleton width="120px" height="24px" class="mb-2" />
        <Skeleton width="50%" height="40px" class="mb-4" />
        <div
          id="quality"
          class="d-flex align-content-center justify-content-center gap-8"
        >
          <div class="img">
            <Skeleton width="560px" height="400px" borderRadius="12px" />
          </div>
          <div class="d-flex mt-2 stat relative">
            <Skeleton width="100%" height="200px" class="mb-4" />
            <div class="stats-section gap-8">
              <div class="stat-item">
                <Skeleton width="80%" height="20px" />
                <Skeleton width="60%" height="50px" class="my-2" />
                <Skeleton width="100%" height="18px" />
              </div>
              <div class="stat-item">
                <Skeleton width="80%" height="20px" />
                <Skeleton width="60%" height="50px" class="my-2" />
                <Skeleton width="100%" height="18px" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- About Section with Skeleton -->
    <div class="relative mt-200px">
      <div>
        <div
          id="quality"
          class="d-flex flex-row-reverse align-content-center justify-content-center gap-8"
        >
          <template v-if="cmsData.length > 0">
            <div class="img mb-5">
              <img
                width="580"
                height="360"
                :src="`${mediaURL}${about_img}`"
                alt="quality"
                style="border-radius: 12px"
                class="p-overflow-hidden"
              />
            </div>
            <div class="d-flex flex-column stat">
              <h4 class="card-subtitle mb-3">{{ about_header }}</h4>
              <h2 class="card-title mb-4">
                {{ about_subheader }}
              </h2>
              <p class="card-paragraph">
                {{ about_paragraph }}
              </p>
            </div>
          </template>
          <template v-else>
            <div class="img mb-5">
              <Skeleton width="580px" height="360px" borderRadius="12px" />
            </div>
            <div class="d-flex flex-column stat">
              <Skeleton width="120px" height="24px" class="mb-3" />
              <Skeleton width="80%" height="40px" class="mb-4" />
              <Skeleton width="100%" height="120px" />
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Email Subscription Section with Skeleton -->
    <div
      class="d-flex align-items-center justify-content-between gap-5 px-50px py-30px bg-gray mt-100px flex-wrap"
      style="border-radius: 12px"
    >
      <template v-if="cmsData.length > 0">
        <div class="d-flex flex-column mx-auto center">
          <h5 class="card-title mb-2">{{ mail_header }}</h5>
          <p class="card-paragraph mw-500px">
            {{ mail_paragraph }}
          </p>
        </div>
        <form class="d-flex gap-4 mx-auto">
          <InputText
            style="width: 278px"
            type="email"
            placeholder="E-mail address"
            required
            v-model="email"
          />
          <Button type="submit" class="choose-button" label="Continue" />
        </form>
      </template>
      <template v-else>
        <div class="d-flex flex-column mx-auto center">
          <Skeleton width="250px" height="36px" class="mb-2" />
          <Skeleton width="400px" height="60px" />
        </div>
        <div class="d-flex gap-4 mx-auto">
          <Skeleton width="278px" height="47px" borderRadius="6px" />
          <Skeleton width="124px" height="47px" borderRadius="6px" />
        </div>
      </template>
    </div>
  </div>

  <!-- Testimonials Section with Skeleton -->
  <div class="relative mt-100px testinomial-container">
    <template v-if="cmsData.length > 0">
      <h4 class="card-subtitle mb-2">{{ testimonial_header }}</h4>
      <h2 class="card-title mw-500px">{{ testimonial_subheader }}</h2>

      <Carousel
        :value="products"
        :numVisible="3"
        :numScroll="1"
        :responsiveOptions="responsiveOptions"
        :showIndicators="false"
        class="testinomial-carousel"
      >
        <template #item="slotProps">
          <div class="testinomial-card">
            <h4>{{ slotProps.data.heading }}</h4>
            <p>
              {{ slotProps.data.content }}
            </p>
            <div class="d-flex mt-4 avatar-info align-items-center">
              <Avatar
                :image="slotProps.data.image"
                class="avatar mr-2"
                shape="circle"
              />
              <div class="d-flex flex-column">
                <div class="avatar-name">{{ slotProps.data.name }}</div>
                <div class="avatar-position">{{ slotProps.data.position }}</div>
              </div>
            </div>
          </div>
        </template>
      </Carousel>
    </template>
    <template v-else>
      <Skeleton width="120px" height="24px" class="mb-2" />
      <Skeleton width="300px" height="40px" class="mb-4" />

      <div class="d-flex gap-4 overflow-hidden">
        <div
          v-for="i in 3"
          :key="i"
          class="testinomial-card"
          style="min-width: 30%"
        >
          <Skeleton width="80%" height="22px" class="mb-3" />
          <Skeleton width="100%" height="80px" class="mb-4" />
          <div class="d-flex mt-4 align-items-center">
            <Skeleton shape="circle" size="60px" class="mr-2" />
            <div class="d-flex flex-column" style="width: 70%">
              <Skeleton width="80%" height="24px" class="mb-1" />
              <Skeleton width="60%" height="24px" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.avatar-info {
  .avatar {
    width: 60px;
    height: 60px;
    object-fit: cover;
    object-position: center;
    flex-shrink: 0;
  }
  .avatar-name {
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    color: #444444;
  }
  .avatar-position {
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    color: #424242;
  }
}
.testinomial-container {
  max-width: 1440px;
  width: 100%;
  margin: auto;
  padding-inline: 20px;
}

.testinomial-card {
  border: 1px solid #eff0f6;
  padding: 32px;
  box-shadow: 0px 5px 14px 0px #080f340a;
  border-radius: 20px;
  margin-right: 30px;
  h4 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 14px;
    color: #444444;
  }
  p {
    font-size: 20px;
    font-weight: 400;
    margin: 0;
    color: #424242;
  }
}
.choose-button {
  border-radius: 6px;
  background: #fc6c2a !important;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  border: 1px solid #fc6c2a !important;
  transition: all 320ms;

  &:hover {
    background: #fff !important;
    color: #fc6c2a;
  }
  &:disabled {
    color: #fff !important;
    opacity: 0.5;
  }
}
.card-subtitle {
  font-weight: 500;
  font-size: 20px;
  color: #fc6c2a;
}
.card-title {
  color: #444444;
  font-size: 36px;
  font-weight: 700;
}
.bg-gray {
  background-color: #f5f5f5;
}

.about-container {
  max-width: 1140px;
  width: 100%;
  margin: auto;
  padding-inline: 20px;

  .title {
    font-weight: 700;
    color: #444444;
  }
  .subtitle {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.2px;
  }
  .card-subtitle {
    font-weight: 500;
    font-size: 20px;
    color: #fc6c2a;
  }
  .card-title {
    color: #444444;
    font-size: 36px;
    font-weight: 700;
  }
  .card-paragraph {
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.2px;
    color: #424242;
  }
}
.stats-section {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: #015cac; // Mavi tonunuzu buradan ayarlayın
  color: white;
  border-radius: 8px;
  max-width: 600px;
  position: absolute;
  bottom: 5%;
  right: 15%;
  padding: 24px;
  align-items: center;
  justify-content: center;
  .mask {
    position: absolute;
    bottom: -60px;
    right: -60px;
  }
  .stat-item {
    margin: auto;
    h3 {
      margin: 0;
      font-size: 20px;
      font-weight: 700;
    }
    p {
      font-size: 50px;
      margin: 0;
      font-weight: 700;
    }
    span {
      margin: 0;
      font-size: 18px;
      font-weight: 400;
    }
  }
}

// Mobil uyumluluk

.testinomial-carousel {
  ::v-deep(.p-carousel-prev) {
    background-color: #ffebcc;
    width: 35px;
    height: 35px;
  }
  ::v-deep(.p-carousel-next) {
    background-color: #ffebcc;
    width: 35px;
    height: 35px;
  }

  ::v-deep(.p-carousel-prev.p-disabled) {
    display: none;
  }

  ::v-deep(.p-carousel-prev-icon) {
    color: #005bab;
  }
  ::v-deep(.p-carousel-next-icon) {
    color: #005bab;
  }
}

@media (max-width: 1100px) {
  .center {
    text-align: center;
  }
  #quality {
    flex-wrap: wrap;
    gap: 0px;

    .img {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .stat {
      flex-direction: column;
    }
    .stats-section {
      position: unset;
      max-width: unset;
    }
  }
}
</style>
